import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState } from 'react';
const DEFAULT_INFRASTRUCTURE = 'azure';
const SgwtWidgetContext = createContext({
    infrastructure: DEFAULT_INFRASTRUCTURE,
    widgets: {},
    registerWidget: () => { },
});
const SgwtWidgetContextProvider = (props) => {
    const infrastructure = useMemo(() => props.infrastructure ?? DEFAULT_INFRASTRUCTURE, [props.infrastructure]);
    // Save all widget
    const [widgets, setWidgets] = useState({});
    // Expose a register method to prevent loading the same widget twice.
    const registerWidget = (widgetName, widget) => {
        // Prevent loop on widget register
        if (!widgets[widgetName]) {
            setWidgets({
                ...widgets,
                [widgetName]: widget,
            });
        }
    };
    return (_jsx(SgwtWidgetContext.Provider, { value: { infrastructure, widgets, registerWidget }, children: props.children }));
};
export { SgwtWidgetContextProvider, SgwtWidgetContext };
//# sourceMappingURL=SgwtWidgetContext.js.map